module.exports = __webpack_public_path__ + "static/couple-hugging-desktop.1c3b7d31.webp";